export const footer = `

    <footer
      class="bg-linear-to-t from-blue-900 to-blue-600 text-white py-10 px-6 mt-24"
    >
      <div class="w-44">
        <a href="/"
        aria-label="Home"
        class="">
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/logo.png"
            alt="ibankey logo"
            class="w-full rounded-md bg-white ml-5 mb-10 py-3 px-5 ml-24 hidden lg:block"
          />
        </a>
      </div>

      <div class="w-full lg:w-[90%] mx-auto">
        <div class="flex gap-20 flex-wrap">
          <div
            class="w-full lg:w-[50%] flex flex-col gap-10 lg:gap-5 sm:flex-row md:flex-row lg:flex-row mt-5 lg:mt-0"
          >
            <div class="w-full float-right text-gray-100">
              <p class="font-semibold mb-3 text-lg">COMPANY</p>
              <ul class="space-y-1 text-sm">
                <li><a 
                href="./about.html"
                aria-label="About"
                >About</a></li>
                <li><a 
                href="./career.html"
                aria-label="Career"
                >Careers</a></li>
                <li><a 
                href="./teams.html"
                aria-label="Teams"
                >Team</a></li>
                <li><a 
                href="./privacy.html"
                aria-label="Privacy Policy"
                >Privacy Policy</a></li>
              </ul>
            </div>
            <div class="w-full  text-gray-100">
              <p class="font-semibold mb-3 text-lg">CONTACT</p>
              <ul class="space-y-1 text-sm">
                <li><a 
                href="./contact.html"
                aria-label="conatct"
                >Contact</a></li>
              </ul>
            </div>
            <div class="w-full text-gray-100">
            <p class="font-semibold mb-3 text-lg">MORE</p>
              <ul class="space-y-1 text-sm">
                <li><a href="https://ibankey.com/lender">Lender</a></li>
                <li><a href="https://ibankey.com/borrower">Borrower</a></li>
                <li><a href="https://ibankey.com/partner">Partner</a></li>
                <li><a href="https://blog.ibankey.com/">Blog</a></li>
              </ul>
            </div>
          </div>
          <!-- <div>
            <h1 class="text-5xl font-semibold text-center items-center">
              Your key to the <br />
              world of Finance
            </h1>
          </div> -->
          <div
            class="px-0 lg:px-4 text-center text-white relative overflow-hidden"
          >
            <!-- Heading -->
            <h2 class="text-xl lg:text-3xl font-semibold mb-4 text-start">
              Subscribe to newsletter
            </h2>
            <p class="text-gray-200 mb-8 text-sm text-start pl-0 lg:pl-2">
              To stay up to date on all the latest news and <br/> offers from us
            </p>

            <!-- Email input and Subscribe button -->
            <div
              class="max-w-md mx-auto flex items-center bg-white rounded-full overflow-hidden shadow-md"
            >
              <input
                type="email"
                placeholder="Enter your email address"
                class="flex-grow px-3 lg:px-5 py-3 text-xs text-gray-700 focus:outline-none"
              />
              <button
                class="bg-red-700 text-xs text-white px-2 lg:px-6 py-3 font-medium hover:bg-red-800 transition-all"
              >
                Subscribe
              </button>
            </div>

            <!-- Decorative food items (optional) -->
            <!-- You can add <img> tags positioned absolutely here to match the original design -->
          </div>
        </div>

        <div
          class="mt-10 border-t border-white/30 pt-4 text-xs text-white/60 flex flex-col md:flex-row justify-between items-center gap-2"
        >
          <p class="text-gray-100 text-xs">
            © 2025 ibankey™. All Rights Reserved.
          </p>
          <div class="space-x-4 text-gray-100 text-sm">
            <a
              href="./privacy.html"
              class="hover:underline text-gray-100 text-xs"
              >Cookies Policy</a
            >
            <a
              href="./privacy.html"
              class="hover:underline text-gray-100 text-xs"
              >Legal Terms</a
            >
            <a
              href="./privacy.html"
              class="hover:underline text-gray-100 text-xs"
              >Privacy Policy</a
            >
          </div>
         <div class="flex items-center space-x-6 mb-4 lg:mb-0 ml-0 lg:ml-24 flex-wrap">
  <!-- Social Icons -->
  <a
    href="https://www.facebook.com/people/Ibankey/61576965883959/"
    aria-label="Visit our Facebook page"
     target="_blank"
    class="group inline-flex items-center justify-center text-gray-100 hover:bg-white hover:text-gray-700 hover:rounded-full w-10 h-10 transition-all duration-300"
  >
    <i class="fab fa-facebook-f text-sm group-hover:text-gray-700" aria-hidden="true"></i>
  </a>

  <a
    href="https://www.instagram.com/_ibankey/"
    aria-label="Visit our Instagram profile"
     target="_blank"
    class="group inline-flex items-center justify-center text-gray-100 hover:bg-white hover:text-gray-700 hover:rounded-full w-10 h-10 transition-all duration-300"
  >
    <i class="fa-brands fa-instagram text-sm group-hover:text-gray-700" aria-hidden="true"></i>
  </a>

  <a
    href="https://x.com/ibankeyredrock"
    aria-label="Visit our Twitter (X) profile"
     target="_blank"
    class="group inline-flex items-center justify-center text-gray-100 hover:bg-white hover:text-gray-700 hover:rounded-full w-10 h-10 transition-all duration-300"
  >
    <i class="fa-brands fa-x-twitter text-sm group-hover:text-gray-700" aria-hidden="true"></i>
  </a>

  <a
    href="https://in.linkedin.com/company/ibankey"
    target="_blank"
    aria-label="Visit our LinkedIn page"
    class="group inline-flex items-center justify-center text-gray-100 hover:bg-white hover:text-gray-700 hover:rounded-full w-10 h-10 transition-all duration-300"
  >
    <i class="fab fa-linkedin-in text-sm group-hover:text-gray-700" aria-hidden="true"></i>
  </a>
</div>

        </div>
      </div>
    </footer>

    `;
